/* ------------------------------------------------
** TAB切换
** 格式
<div class="tab-hd" tab-name="tabname">
    <div class="item"></div>
    <div class="item"></div>
</div>
<div class="tab-md" tab-name="tabname">
    <div class="tab-group"></div>
    <div class="tab-group"></div>
</div>
** tabid自定义，tab-hd和tab-md的tabname需保持一致
** 当需要悬停显示时，需要在tab-hd中添加class:hover
** 注意：当存在多个tab-hd或tab-md有相同的
--------------------------------------------------*/
//TAB初始化
$(function () {
    // TAB组件事件切换函数
    function changeTab(tabname, index) {
        $(`.tab-hd[tab-name=${tabname}]`).each(function () {
            $(this).children(".item").removeClass("active").eq(index).addClass("active");
            console.log(`${tabname}hd的状态改变了`)
        });
        $(`.tab-md[tab-name=${tabname}]`).each(function () {
            console.log(`正在检查$(this)`)
            console.log($(this));
            $(this).children(".tab-group").hide().eq(index).show();
            console.log(`${tabname}md的状态改变了`)
        })
    }
    // tab初始化
    $(".tab-hd").each(function () {
        $(this).children(".item").eq(0).addClass("active");
    });
    $(".tab-md").each(function () {
        $(this).children(".tab-group").hide().eq(0).show();
    });
    //TAB点击事件
    $(".tab-hd .item").click(function () {
        var index = $(this).index();
        var tabname = $(this).parents(".tab-hd").attr("tab-name");
        console.log(`点击了${tabname}`)
        changeTab(tabname, index);
    });
    // TAB悬停事件
    $(".tab-hd.hover .item").hover(function () {
        var index = $(this).index();
        var tabname = $(this).parents(".tab-hd").attr("tab-name");
        changeTab(tabname, index);
    })
});